"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountCancel = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerAccountCancel(eventLabel) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'CustomerAccount',
        eventAction: 'Cancel',
        eventLabel,
        nonInteraction: false,
    });
}
exports.trackCustomerAccountCancel = trackCustomerAccountCancel;
//# sourceMappingURL=trackCustomerAccountCancel.js.map